import { useEffect } from "react";

/** DOM id injected by Beamer; we poll until it exists then toggle visibility for admins. */
export const BEAMER_SELECTOR_ELEMENT_ID = "beamerSelector";

export const BEAMER_SELECTOR_ADMIN_POLL_INTERVAL_MS = 100;

/** Poll for Beamer's injected node and show it only for admins. */
export function useSettingsBeamerSelectorVisibility(
  isAdmin: boolean | null
): void {
  useEffect(() => {
    const intervalId = setInterval(() => {
      const el = document.getElementById(BEAMER_SELECTOR_ELEMENT_ID);
      if (el) {
        clearInterval(intervalId);
        if (isAdmin === true) {
          el.style.display = "block";
        }
      }
    }, BEAMER_SELECTOR_ADMIN_POLL_INTERVAL_MS);

    return () => {
      clearInterval(intervalId);
      const el = document.getElementById(BEAMER_SELECTOR_ELEMENT_ID);
      if (el) {
        el.style.display = "none";
      }
    };
  }, [isAdmin]);
}
